const actions = Object.freeze({
  folders: {
    ajaxUrl: 'apia.modals.FoldersAction.run',
    loadFileSystemStructureTree: 'loadFileSystemStructureTree',
    loadFilesForFolder: 'loadFilesForFolder',
  },
  administration: {
    aiConnectors: {
      edit: {
        back: 'list',
        confirm: 'confirm',
        testConnector: 'testConnectorFromEdition',
      },
      create: 'create',
      delete: 'delete',
      getParameters: 'getConnectorParameters',
      setDefault: 'setDefaultFromListModal',
      testConnector: 'testConnectorFromList',
      update: 'update',
      loadDeps: 'loadDeps',
    },
    common: {
      adtInfo: 'adtInfo',
      loadUpsertion: 'loadUpsertion',
    },
    customParameters: {
      delete: 'delete',
      view: 'goToViewMode',
    },
    customComponent: {
      edit: {
        back: 'list',
        confirm: 'confirm',
      },
      create: 'create',
      delete: 'delete',
      update: 'update',
      loadDeps: 'loadDeps',
    },
    decAdm: {
      edit: {
        back: 'list',
        confirm: 'confirm',
        deleteUsrImage: 'deleteUsrImageFromEdit',
        uploadImage: 'ajaxUploadStartImage',
      },
      checkUserPermits: 'checkUserPermits',
      clone: 'clone',
      create: 'create',
      delete: 'delete',
      download: 'downloadExcelForAdmDesc',
      getGenUserPools: 'getGenUserPools',
      getUserHierarchyPools: 'getUserHiePools',
      getUserOrgRoles: 'getUserOrgRoles',
      getUserStyles: 'getUserStyles',
      initDashboard: 'initUserDashboard',
      loadDeps: 'loadDeps',
      loadUpsertion: 'loadUpsertion',
      lock: 'startUserLock',
      refresh: 'refresh',
      unlock: 'unlockUsers',
      update: 'update',
      upload: 'ajaxUploadStart',
    },
    emailReset: {
      confirmEmail: 'confirmEmail',
    },
    functionalities: {
      create: 'create',
      confirm: 'confirm',
      initProcessDelete: 'initProcessDelete',
      update: 'update',
      tree: 'tree',
      loadTreeXml: 'loadTreeXml',
    },
    groups: {
      edit: {
        back: 'list',
        confirm: 'confirm',
      },
      clone: 'clone',
      create: 'create',
      createFile: 'createExcelFile',
      delete: 'delete',
      download: 'download',
      getEnvironments: 'getEnvironments',
      loadDeps: 'loadDeps',
      loadUpsertion: 'loadUpsertion',
      update: 'update',
      upload: 'ajaxUploadStart',
    },
    hierarchicalStructure: {
      confirm: 'confirm',
      createFile: 'createModalExport',
      download: 'download',
      loadEnvironments: 'loadEnvironments',
      loadStructure: 'loadStructure',
      loadUsers: 'loadUsers',
      upload: 'ajaxUploadStart',
    },
    passwordReset: {
      userSelected: 'userSelected',
    },
    profiles: {
      edit: {
        back: 'list',
        confirm: 'confirm',
      },
      clone: 'clone',
      create: 'create',
      delete: 'delete',
      getEnvironments: 'loadEnvs',
      loadDeps: 'loadDeps',
      loadUpsertion: 'loadUpsertion',
      update: 'update',
    },
    orgRole: {
      edit: {
        back: 'list',
        confirm: 'confirm',
      },
      clone: 'clone',
      create: 'create',
      delete: 'delete',
      loadDeps: 'loadDeps',
      loadUpsertion: 'loadUpsertion',
      refresh: 'refresh',
      release: 'startFreeRole',
      update: 'update',
    },
    orgUnit: {
      edit: {
        back: 'list',
        confirm: 'confirm',
      },
      create: 'create',
      createFile: 'createExcelFile',
      delete: 'delete',
      download: 'downloadUnits',
      loadUpsertion: 'loadUpsertion',
      update: 'update',
      upload: 'ajaxUploadStart',
    },
    scheduler: {
      loadDeps: 'loadDeps',
      runNow: 'runNow',
      delete: 'delete',
      enableDisable: 'enableDisable',
      showSchInfo: 'showSchInfo',
      showWaitingSchedulers: 'showWaitingSchedulers',
      reloadSchWarning: 'reloadSchWarning',
      liveView: 'liveView',
      create: 'create',
      update: 'update',
    },
    users: {
      edit: {
        back: 'list',
        confirm: 'confirm',
        deleteUsrImage: 'deleteUsrImageFromEdit',
        uploadImage: 'ajaxUploadStartImage',
      },
      clone: 'clone',
      create: 'create',
      createFile: 'createExcelFile',
      delete: 'delete',
      download: 'download',
      getUserEnvironments: 'getUserEnvironments',
      getUserOrgRoles: 'getUserOrgRoles',
      getUserPools: 'getUserPools',
      getUserProfiles: 'getUserProfiles',
      getUserStyles: 'getUserStyles',
      initDashboard: 'initUserDashboard',
      loadDeps: 'loadDeps',
      loadRolePoolsAndProfiles: 'loadRolePoolsAndProfiles',
      loadUpsertion: 'loadUpsertion',
      lock: 'startUserLock',
      refresh: 'refresh',
      unlock: 'unlockUsers',
      update: 'update',
      upload: 'ajaxUploadStart',
    },
  },
  common: {
    toggleFavoriteAjaxUrl: 'apia.splash.MenuAction.run',
    toggleFavorite: 'toggleFavorite',
    lists: {
      adtInfo: 'adtInfo',
    },
  },
  control: {
    processes: {
      list: 'list',
      page: 'page',
      filter: 'filter',
      prepareChangePriorityModal: 'prepareChangePriorityModal',
      changePriority: 'changePriority',
      suspend: 'suspend',
      restore: 'restore',
      loadProInst: 'loadProInst',
      confirmFinalize: 'confirmFinalize',
      startChangeDateModal: 'startChangeDateModal',
      task: 'task',
      loadTasks: 'loadTasks',
      loadBottomGrids: 'loadBottomGrids',
      confirm: 'confirm',
      confirmChangeDateModal: 'confirmChangeDateModal',
    },
    tasks: {
      startRelease: 'startRelease',
      confirmRelease: 'confirmRelease',
      startReasig: 'startReasig',
      confirmReasign: 'confirmReasign',
    },
    widgetsSupervision: {
      approveValue: 'approveValue',
    },
  },
  design: {
    projectAnalysis: {
      apply: 'apply',
      createApiaObjects: 'createApiaObjects',
      export: 'export',
      generateObject: 'generateObject',
      generateProcess: 'generateProcess',
      getFormFromImage: 'getFormFromImage',
      getStatus: 'getStatus',
      loadApiaObjects: 'loadApiaObjects',
    },
    semanticSearch: {
      edit: {
        back: 'list',
        confirm: 'confirm',
      },
      create: 'create',
      delete: 'delete',
      update: 'update',
      clone: 'clone',
    },
  },
  desktop: {
    ajaxUrl: 'apia.splash.ApiaDeskAction.run',
  },
  execution: {
    entitiesInstList: {
      create: 'create',
      update: 'update',
      checkAction: 'checkAction',
      delete: 'delete',
      clone: 'clone',
    },
  },
  finder: {
    disableTable: 'disableTable',
  },
  menu: {
    ajaxUrl: 'apia.splash.MenuAction.run',
    filterFunctionality: 'filterFunctionality',
    filterMenu: 'filterMenu',
  },
  modals: {
    functionalities: {
      loadUserEnvs: 'loadUserEnvironments',
      loadUserFncTree: 'loadUserFunctionalitiesTreeMode',
    },
    documents: {
      custom: {
        init: 'init',
        download: 'download',
      },
    },
  },
  monitor: {
    common: {
      adtInfo: 'adtInfo',
    },
    entities: {
      getBusEntityInfoForMonDocument: 'getBusEntityInfoForMonDocument',
    },
    processes: {
      filter: 'filterProcesses',
      getProcessInfoForMonDocument: 'getProcessInfoForMonDocument',
      export: 'download',
      getGanttJSON: 'getGanttJSON',
    },
    documents: {
      init: 'init',
      filter: 'filter',
      loadMetadata: 'loadMetadata',
      loadDownloadDocument: 'loadDownloadDocument',
      loadDocInformation: 'loadDocInformation',
      download: 'download',
      loadDocVersions: 'loadDocVersions',
      loadDocDwnInformation: 'loadDocDwnInformation',
      custom: {
        init: 'init',
        filter: 'filter',
        loadMetadata: 'loadMetadata',
        loadDocInformation: 'loadDocInformation',
        loadDocVersions: 'loadDocVersions',
        download: 'download',
      },
    },
    tasks: {
      export: 'downloadTask',
      getTaskInfoForMonDocument: 'getTaskInfoForMonDocument',
    },
  },
  query: {
    entitiesInstList: {
      checkAction: 'checkAction',
      clone: 'clone',
      create: 'create',
      delete: 'delete',
      export: 'doExport',
      update: 'update',
    },
    ProcessMonitor: {
      viewDocs: 'getQueryInfoForMonDocument',
    },
    offline: {
      getList: 'getList',
      openResultPage: 'openResultPage',
    },
  },
  splash: {
    about: 'splashAbout',
    ajaxUrl: 'apia.splash.SplashAction.run',
    changeDefaultDashboard: 'splashStartDash',
    changeLanguage: 'splashLangConfirm',
    changePassword: 'splashResetPass',
    changeStyle: 'splashChangeStyle',
    changeVisiblePanels: 'splashEdit',
    environments: {
      getAll: 'getOtherEnvironments',
      toggle: 'splashEditEnvConfirm',
    },
    getLanguages: 'getAllLanguages',
    reset: 'splashResetHome',
  },
  uploader: {
    associateExistingFile: 'associateExistingFile',
  },
});

export default actions;
